import { ISimulation, ITeamArchetyprRawPscoreBeforeAfter } from "./IPerformanceVersion2";

export interface IPlayerMetrics {
  [key: string]: number | null;
  accelerations: number | null;
  aerialDuels: number | null;
  clearances: number | null;
  counterpressingRecoveries: number | null;
  crosses: number | null;
  dribbles: number | null;
  fieldAerialDuels: number | null;
  forwardPasses: number | null;
  headShots: number | null;
  interceptions: number | null;
  linkupPlays: number | null;
  longPasses: number | null;
  offensiveDuels: number | null;
  opponentHalfRecoveries: number | null;
  passes: number | null;
  passLength: number | null;
  recoveries: number | null;
  shotsBlocked: number | null;
  throughPasses: number | null;
  touchInBox: number | null;
  xgShot: number | null;
  dribbleDistanceFromOpponentGoal: number | null;
  defensiveDuelsWon: number | null;
  foulsSuffered: number | null;
  fouls: number | null;
  progressivePasses: number | null;
  nonHeadShots: number | null;
}

export interface ITeamMetrics{
  [key: string]: number | null;
  accelerations: number | null;
  aerialDuels: number | null;
  pressing: number | null;
  crosses: number | null;
  defensiveDuels: number | null;
  interceptions: number | null;
  dribbles: number | null;
  forwardPasses: number | null;
  headShots: number | null;
  linkupPlays: number | null;
  // longPasses: number | null;
  offensiveDuels: number | null;
  passes: number | null;
  passLength: number | null;
  throughPasses: number | null;
  touchInBox: number | null;
  xgShot: number | null;
  xgShotAgainst: number | null;
  fouls: number | null;
  passesToFinaleThird: number | null;
  passingRate: number | null;
  shots: number | null;
}
export interface IArchetypeData {
  archetypeId: number;
  teamId: number;
  seasonId: number;
  competitionId: number;
  archetypeName: string;
  minutes: number;
  playerRow: IPlayerMetrics;
  playerPscore: IPlayerMetrics;
  footprintRow: IPlayerMetrics;
  footprintPscore: IPlayerMetrics;
  maxValue?: number;
}

export interface ITeamArchetypeData{
  coachBest: any;
  archetypesBest: any;
  archetypeId: number;
  teamId: number;
  seasonId: number;
  competitionId: number;
  archetypeName: string;
  minutes: number;
  ppg: number,
  usagePercentage: number,
  playerRow: ITeamMetrics;
  playerPscore: ITeamMetrics;
  footprintRow: ITeamMetrics;
  footprintPscore: ITeamMetrics;
  maxValue?: number;
  teamRow: ITeamMetrics;
  teamPscore: ITeamMetrics;
  formationName: string;
  coachId: number;
  coachName: string
}

export interface IProcessedMetric {
  segment: string;
  value: number;
  afterValue?: number;
  rawScore?: number;
}

export interface IProcessedArchetypeData {
  player: IProcessedMetric[];
  average: IProcessedMetric[];
  isTeam: boolean;
}

export interface IProceedSimulationData{
  player: IProcessedMetric[];
  average: IProcessedMetric[];
  isTeam: boolean;
}

export interface IProcessdAvrageData{
  average:IProcessedMetric[];
}

export interface IPolarAreaChart {
  data?: IProcessedArchetypeData;
  width: number;
  height: number;
  colorIndex?: number;
  averageData?: IProcessedArchetypeData;
  isForComparison? : boolean;
  isComparisonBlackLine?: boolean
}

export interface SegmentData {
  startAngle: number;
  endAngle: number;
  value: number;
  afterValue?: number;
  segment: string;
}

export const processArchetypeData = (archetype: IArchetypeData) => {
  const metricsToInclude = [
   "xgShot","linkupPlays", "headShots", "touchInBox" ,"accelerations","dribbles", "nonHeadShots",
   "crosses", "passLength" , "passes", "forwardPasses", "throughPasses", "longPasses", "offensiveDuels", "progressivePasses",  "dribbleDistanceFromOpponentGoal", "foulsSuffered",
   "interceptions","aerialDuels",  "fieldAerialDuels", "recoveries", "counterpressingRecoveries" , "opponentHalfRecoveries", "fouls", "defensiveDuelsWon", "shotsBlocked", "clearances"
  ];
  const validMetrics = metricsToInclude.filter(
    (metric) => archetype?.playerPscore[metric]! !== null || archetype?.footprintPscore[metric]! !== null
  );
  return {
    player: validMetrics?.map((metric) => ({
      segment: metric,
      value: archetype?.playerPscore[metric]! || 0,
      rawScore: archetype?.playerRow[metric]! || 0,
    })),
    average: validMetrics?.map((metric) => ({
      segment: metric,
      value: archetype?.footprintPscore[metric]! || 0,
      // rawScore: archetype?.footprintRow[metric] || 0,
    })),
    isTeam: false,
  };
};


export const processTeamArchetypeData = (archetype: ITeamArchetypeData) => {
  const metricsToInclude = [
      "offensiveDuels",
      "shots",
      "xgShot",
      "linkupPlays",
      "headShots",
      "touchInBox",
      "accelerations",
      "dribbles",
      "crosses",
      "passesToFinaleThird",
      "passLength",
      "passes",
      "passingRate",
      "forwardPasses",
      "throughPasses",
      //"longPasses",
      "aerialDuels",
      "pressing",
      "interceptions",
      "xgShotAgainst",
      "defensiveDuels",
      "fouls",
      "dangerousOpponentHalfRecoveries",
   
  ];

  const validMetrics = metricsToInclude?.filter(
    (metric) => archetype?.teamPscore[metric]! !== null || archetype?.footprintPscore[metric]! !== null
  );
  return {
    player: validMetrics?.map((metric) => ({
      segment: metric,
      value: archetype?.teamPscore[metric]! || 0,
      rawScore: archetype?.teamRow[metric]! || 0,
    })),
    average: validMetrics?.map((metric) => ({
      segment: metric,
      value: (archetype?.footprintPscore[metric]!) || 0,
      // rawScore: archetype?.footprintRow[metric] || 0,
    })),
    isTeam: true,
  };
};

export const processTeamSwapArchetypeData = (archetype: ISimulation) => {
  const metricsToInclude = [
      "offensiveDuels",
      "shots",
      "xgShot",
      "linkupPlays",
      "headShots",
      "touchInBox",
      "accelerations",
      "dribbles",
      "crosses",
      "passesToFinaleThird",
      "passLength",
      "passes",
      "passingRate",
      "forwardPasses",
      "throughPasses",
      //"longPasses",
      "aerialDuels",
      "pressing",
      "interceptions",
      "xgShotAgainst",
      "defensiveDuels",
      "fouls",
      "dangerousOpponentHalfRecoveries",
   
  ];

    const validMetrics = metricsToInclude?.filter(
    (metric) => archetype?.teamArchetypePscoreBefore[metric]! !== null || archetype?.teamArchetypePscoreBefore[metric]! !== null
  );
  return {
    player: validMetrics?.map((metric) => ({
      segment: metric,
      value: archetype?.teamArchetypePscoreBefore[metric]! || 0,
      afterValue : archetype?.teamArchetypePscoreAfter[metric]! || 0,
      rawScore: archetype?.teamArchetypeRawBefore[metric]! || 0,
    })),
    average: validMetrics?.map((metric) => ({
      segment: metric,
      value: (archetype?.targetedTeamPscore[metric]!)! || 0,
      // rawScore: archetype?.footprintRow[metric] || 0,
    })),
     isTeam: true,
  };
};


export const archetypeColorIndexes = [
  "#00D1A8",
  "#686e6aff",
  "#C9F0B5",
  "#FFC2C2",
  "#FF7800",
  "#64ADDB",
  "#FF3864",
  "#00A1E4",
  "#F2E94E",
];

export const groupColors = {
  finalThird: "#FFC2C2",
  buildUpPlay: "#C9F0B5",
  defensivePlay: "#64ADDB",
};

export const swapGroupColors = {
  finalThird: "#FFE3E3",
  buildUpPlay: "#E6F8DD",
  defensivePlay: "#CFE6F4",
};

export const DarkgroupColors = {
  finalThird: "#CC9999",
  buildUpPlay: "#A3C98A", 
  defensivePlay: "#4A91B3", 
};

export const teammetricsGrouped = {
  finalThird: [
      "offensiveDuels",
      "shots",
      "xgShot",
      "linkupPlays",
      "headShots",
      "touchInBox",
      "accelerations",
      "dribbles",
  ],
  buildUpPlay: [
      "crosses",
      "passesToFinaleThird",
      "passLength",
      "passes",
      "passingRate",
      "forwardPasses",
      "throughPasses",
  ],
  defensivePlay: [
      "aerialDuels",
      "pressing",
      "interceptions",
      "xgShotAgainst",
      "defensiveDuels",
      "fouls",
      "dangerousOpponentHalfRecoveries",
  ],
  };
  export const playermetricsGroup = {
    finalThird: ["xgShot","linkupPlays", "headShots", "touchInBox" ,"accelerations",,"dribbles", "nonHeadShots"],
    buildUpPlay: ["crosses", "passLength" , "passes", "forwardPasses", "throughPasses", "longPasses", "offensiveDuels", "progressivePasses",  "dribbleDistanceFromOpponentGoal", "foulsSuffered"],
    defensivePlay: ["interceptions","aerialDuels",  "fieldAerialDuels", "recoveries", "counterpressingRecoveries" , "opponentHalfRecoveries", "fouls", "defensiveDuelsWon", "shotsBlocked", "clearances"]
  }